<template>
  <b-row class="px-3">
    <b-col lg="5">
      <b-carousel id="prod-img-carousel" img-height="300" v-model="selectedPic">
        <b-carousel-slide v-for="img in carouselImages" :key="img.id" :img-src="img.link"></b-carousel-slide>
      </b-carousel>
      <b-row no-gutters class="mt-3">
        <b-col cols="2" v-for="(img, idx) in carouselImages" :key="img.id" class="mr-2 mb-1">
          <b-card no-body class="image-indicator" @click="selectedPic=idx">
            <b-card-img :src="img.thumb" alt="production images"></b-card-img>
          </b-card>
        </b-col>
      </b-row>
    </b-col>
    <b-col lg="5" class="mt-2 pl-5 pr-5">
      <h4>{{name}}</h4>
      <h5 v-if="ori_price" class="pl-1 ori-price" >$ {{ori_price}}</h5>
      <h4 class="pl-1" :class="[ori_price? 'price':'price-without-ori-price']" >$ {{price}}</h4>
      <p class="mt-5 pb-3 text-secondary" style=" border-bottom: 1px dotted #ddd;">{{description}}</p>
      <div v-if="isSellOut">
        <h5 class="text-danger mt-5">所有型號缺貨中</h5>
      </div>
      <div v-else>
        <b-form-group id="size-radio-group-fieldset" label="規格" label-size="md" label-for="size-radio-group">
          <div class="py-1">
            <b-button v-for="size in sizeOptions" :key="size.id"
              :class="selectedSize===size.id? 'btn-pur-mid':'btn-pur-outline'"
              @click="selectedSize=size.id" class="mr-2"
            >{{size.name}}</b-button>
          </div>
        </b-form-group>
        <b-form-group v-if="isSelectedSizeRemains" id="amount-fieldset" label="數量" label-size="md" label-for="amount" class="mt-4">
          <b-row no-gutters>
            <b-col lg="6">
              <b-input-group class="py-1">
                <template v-slot:prepend>
                  <b-button @click="amount--" variant="outline-secondary" class="border" :disabled="amount===1">
                    <font-awesome-icon icon="minus" size="sm"></font-awesome-icon>
                  </b-button>
                </template>
                <b-form-input id="buy-amount" v-model="amount" required type="number" min="1" class="text-center"></b-form-input>
                <template v-slot:append>
                  <b-button @click="amount++" variant="outline-success" class="border" :disabled="amount===isSelectedSizeRemains">
                    <font-awesome-icon icon="plus" size="sm"></font-awesome-icon>
                  </b-button>
                </template>
              </b-input-group>
            </b-col>
            <b-col lg="6" class="px-2">
              <h6 class="m-0" >還剩 <u class="text-danger">{{isSelectedSizeRemains}}</u> 件</h6>
            </b-col>
          </b-row>
        </b-form-group>
        <h5 v-else class="text-danger py-3">該型號缺貨中</h5>
        <b-row>
          <b-col md="6" cols="12">
            <b-button @click="onClickAddToCart" block size="md" class="mt-2 py-2 btn-pur-light">加入購物車</b-button>
          </b-col>
          <b-col md="6" cols="12">
            <b-button @click="onClickAddAndPay" block size="md" class="mt-2 py-2 btn-pur-mid">立即結帳</b-button>
          </b-col>
        </b-row>
      </div>
    </b-col>
    <b-col cols="12" class="mt-2 mh-5"></b-col>
    <b-col cols="12" class="text-left mh-60">
      <b-tabs content-class="mt-3" justified variant="primary">
        <b-tab title="特色" active v-html="raw_feature_html"></b-tab>
        <b-tab title="規格" v-html="raw_specification_html"></b-tab>
        <b-tab title="購買須知" v-html="raw_notice_html"></b-tab>
      </b-tabs>
    </b-col>
  </b-row>
</template>
<script>
import { library } from '@fortawesome/fontawesome-svg-core'
import { faPlus, faMinus } from '@fortawesome/free-solid-svg-icons'
library.add(faPlus, faMinus)
export default {
  props: {
    id: String,
    name: String,
    description: String,
    ori_price: Number,
    price: Number,
    pics: { type: Array, default: () => [] },
    size: { type: Array, default: () => [] },
    raw_feature_html: String,
    raw_specification_html: String,
    raw_notice_html: String
  },
  data () {
    return {
      selectedPic: null,
      selectedSize: null,
      amount: 1
    }
  },
  computed: {
    carouselImages () {
      return this.pics.map(item => {
        const { id } = item
        return {
          id,
          link: this.$api.catalogImageLink(this.id, id),
          thumb: this.$api.catalogThumbImageLink(this.id, id)
        }
      }).filter(item => !!item)
    },
    isSellOut () {
      return !this.size.find(item => item.amount > 0)
    },
    sizeOptions () {
      return this.size.map(item => {
        const { id, name, amount } = item
        return { id, name, amount }
      })
    },
    theCargo () {
      return {
        catalog: this.id,
        size: this.selectedSize,
        amount: this.amount
      }
    },
    isSelectedSizeRemains () {
      const find = this.size.find(item => item.id === this.selectedSize)
      if (!find) return false
      return find.amount
    }
  },
  methods: {
    validChecker () {
      if (!this.selectedSize) {
        this.showSizeError()
        return false
      }
      if (!this.amount > 0) {
        this.showAmountError()
        return false
      }
      return true
    },
    onClickAddToCart () {
      if (this.validChecker()) {
        this.$emit('submit', this.theCargo, false)
      }
    },
    onClickAddAndPay () {
      if (this.validChecker()) {
        this.$emit('submit', this.theCargo, true)
      }
    },
    showAmountError () {
      this.$bvToast.toast('輸入的數量不正確', {
        title: '數量錯誤',
        variant: 'warning'
      })
    },
    showSizeError () {
      this.$bvToast.toast('請選擇欲購買的商品規格', {
        title: '規格錯誤',
        variant: 'warning'
      })
    }
  },
  watch: {
    size (val) {
      if (val && Array.isArray(val) && val.length > 0) {
        const [ first ] = val
        this.selectedSize = first.id
      }
    },
    amount (val) {
      let intVal = parseInt(val)
      if (intVal < 1) {
        intVal = 1
      } else if (intVal > this.isSelectedSizeRemains) {
        intVal = this.isSelectedSizeRemains
      }
      // dont update value immediately, that won't work
      this.$nextTick(() => {
        this.amount = intVal
      })
    }
  }
}
</script>
<style scoped>
  .image-indicator {
    cursor: pointer;
	height: 80px;
  }
  .image-indicator img {
	height: 100%;
  }
  .image-indicator img:hover {
	border: 2px solid #6c757d;
  }
  .ori-price {
    color: #999999;
    text-decoration:line-through;
	font-size: 1rem;
  }
  .price {
    color: #5169de;
  }
  .price-without-ori-price {
    color: #7b8cde;
  }
  .mh-5 {
    min-height: 5rem;
  }
  .mh-60 {
    min-height: 60rem;
  }
  h6.m-0 {
	line-height: 46px;
  }
  .tab-content table td, .table th {
    border: 1px solid #dee2e6;
  }
  @media (max-width: 992px) {
  div.pr-5.pl-5 {
	padding-left: 1rem!important;
  }}
</style>